import { Functionality, ComponentConstants } from "@rhinov/savane-js";

export class FunctionalityComponentWidget {

    component: Functionality;
    index: number;
    
    rename = (event: any) => {
        this.component.functionalityName = event.currentTarget.value;
        this.component.functionalityId = ComponentConstants.Functionalities.Custom;
    }

    constructor(component: Functionality, index: number) {
        this.component = component;
        this.index = index;
    }

    init(endCallback: CallableFunction) {
        endCallback();
    }

    setListener() {
        let element = document.getElementById(`renameComponent-${this.index}`) as HTMLInputElement;
        element.value = this.component.functionalityName!;
        element.addEventListener('change', this.rename);
    }

    destroy() {
        let element = document.getElementById(`renameComponent-${this.index}`);
        if (!element) return;
        element.removeEventListener('change', this.rename);
    }

    html(): string {
        return `
            <div class="component-action" style="flex-flow: row wrap;">
              <div class="input-wrapper">
                  <h5>Nom de la pièce:</h5>
                  <input id="renameComponent-${this.index}" class="inputEnterValited form-control"
                      style="width:240px;padding:4px;margin-left:4px">
              </div>
            </div>
        `
    }
}